import React from 'react';
import moment from "moment";
import { Link } from 'react-router';
import API from "../base/API";
import Auth, { hasPermission, getUser } from "../auth/Auth";
import Storage from "../base/Storage";
import SorTable from "../base/SorTable";
import DeleteButton from "../base/DeleteButton";
import EditButton from "../base/EditButton";
import * as TestsCreators from "../../redux/creators/tests";
import { connect } from "react-redux";
import { translate } from "../base/Translation";

export class Tests extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_tests: "/test/list?limit_from=:from&limit_max=:to&brand=:brand",
			delete_test: "/test/delete/:test"
		});

		let tableColumns = [];

		if (getUser().role === 4) {
			tableColumns = [
				{ name: "name", display: translate("Názov"), sort: true, width: 35 },
				{ name: "brand", display: translate("Značka"), sort: true, width: 11 },
				{ name: "branch", display: translate("Prevádzka"), sort: true, width: 20 },
				{ name: "city", display: translate("Obec"), sort: true, width: 12 },
				{ name: "status", display: translate("Stav"), sort: true, width: 9 },
				{ name: "date_date", display: translate("Dátum testu"), sort: true, width: 10 },
				{ name: "options", display: " ", width: 3 }
			];
		} else {
			tableColumns = [
				{ name: "result", display: "#", sort: true, width: 3 },
				{ name: "result_perc", display: "Výsl.", sort: true, width: 5 },
				{ name: "trend", display: "Trend", sort: true, width: 5 },
				{ name: "date_date", display: translate("Dátum testu"), sort: true, width: 10 },
				{ name: "branch", display: translate("Prevádzka"), sort: true, width: 20 },
				{ name: "city", display: translate("Obec"), sort: true, width: 12 },
				{ name: "representative", display: translate("Predajca"), sort: true, width: 10 },
				{ name: "external", display: translate("Externý používateľ"), sort: true, width: 13 },
				/*{ name: "name", display: translate("Názov"), sort: true, width: 22 },*/
				/*{ name: "brand", display: translate("Značka"), sort: true, width: 11 },*/
				{ name: "status", display: translate("Stav"), sort: true, width: 9 },
				{ name: "options", display: " ", width: 5 }
			];
		}

		this.state = {
			limit_from: 0,
			limit_to: 99999,
			tests: [],
			tableData: [],
			tableColumns: tableColumns
		};
	}

	convertDataForTable(data) {
		return data.map(function (test) {
			let data = {};
			data.result_perc = (
				<div>
					<span>{test.result.percent}</span>
					<span> %</span>
				</div>
			);
			data.trend = (
				<div>
					<span style={{ display: "none" }}>{test.trend}</span>
					<span><span style={{ color: test.trend ? "green" : 'red' }} className={"glyphicon glyphicon-chevron-" + (test.trend ? "up" : 'down')} /></span>
				</div>
			);
			data.result = (
				<div>
					<span style={{ display: "none" }}>{test.result.percent}</span>
					<span style={{ color: (test.result.success ? "green" : "red") }} className={"glyphicon glyphicon-" + (test.result.success ? "ok" : "remove")} title={test.result.percent + "%"} />
				</div>
			);
			data.name = (
				<div>
					<Link to={"/tests/" + test.id}>{test.name}</Link>
				</div>
			);
			data.external = getUser().role >= 5 ? (test.external_user_data ? test.external_user_data.name : translate("neuvedené")) : "---";
			data.brand = test.branch_data.brand;
			data.branch = getUser().role === 4 ? test.branch_data.name : <div><Link to={"/tests/" + test.id}>{test.branch_data.name}</Link></div>;;
			data.city = test.branch_data.address.split(",")[0];
			data.status = test.status;
			data.date_date = getUser().role === 4 ? moment(test.date, "DD/MM/YYYY").format("D.M.Y") : <div><Link to={"/tests/" + test.id}>{moment(test.date, "DD/MM/YYYY").format("D.M.Y")}</Link></div>;
			data.representative = test.representative ? test.representative : "---";
			data.options = (
				<div>
					&nbsp;&nbsp;
					<EditButton to={"/tests/edit/" + test.id} className="btn btn-xs btn-primary" permission={hasPermission("TestEdit", test)} />
					&nbsp;&nbsp;
					<DeleteButton onClick={this.deleteTest.bind({ test: test.id, currentComponent: this })} permission={"TestDelete"} />
				</div>);
			return data;
		}.bind(this));
	}

	fetchData() {
		let brandFilter = Storage.get("brand_filter");
		this.props.fetch(this.state.limit_from, this.state.limit_to, (brandFilter ? brandFilter.id : "all"));
	}

	deleteTest(evt) {
		this.currentComponent.api.request({
			route: "delete_test",
			params: { test: this.test },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	render() {
		const data = this.convertDataForTable(this.props.testsStore.items);

		return (
			<SorTable columns={this.state.tableColumns} per_page={1000} data={data} headers={true} searchBy="name" title={translate("Testy")} right={() => {
				if (Storage.get("allowed_components").indexOf("TestNew") === -1) {
					return "";
				}

				return (
					<Link to="/tests/add/new" className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
				)
			}} beforeSearchInput={(data) => {
				let totalPertcent = 0;
				data.forEach((item) => {
					totalPertcent += parseInt(item.result_perc.props.children[0].props.children, 10);
				});

				if([4].indexOf(getUser().role) !== -1){
					return;
				}

				return (
					<span className="pull-right" style={{ lineHeight: "3rem", paddingRight: "2rem" }}>
						{translate("Priemerný výsledok: ")} {Math.round(totalPertcent / data.length) + " %"}
					</span>
				);
			}} />
		);
	}
}


const mapStateToProps = (state) => {
	return { testsStore: state.tests };
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetch: (from, to, brand) => dispatch(TestsCreators.fetch(from, to, brand))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Tests);


// WEBPACK FOOTER //
// ./src/modules/test/Tests.js